import {Path, Svg} from 'react-native-svg'

import {useSemanticTokens} from '#/wsocial/service/design-system'

export const PersonIcon = () => {
  const tokens = useSemanticTokens()
  return (
    <Svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      style={{flexShrink: 0}}>
      <Path
        fill={tokens.onboarding.btnPrimaryBg}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM7.5 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM5.678 19h12.644c-.71-2.909-3.092-5-6.322-5s-5.613 2.091-6.322 5Zm-2.174.906C3.917 15.521 7.242 12 12 12c4.758 0 8.083 3.521 8.496 7.906A1 1 0 0 1 19.5 21h-15a1 1 0 0 1-.996-1.094Z"
      />
    </Svg>
  )
}

export default PersonIcon
